import React, { Component } from 'react';
import cookie from 'react-cookies';
import axios from 'axios';
import './RAPriceBox.css';
import Config from '../Configs/criteria.json';

export default class RAPriceBox extends Component {
    constructor(props) {
        super(props);

        this.intperLookup = [];
        this.intperLookup[0] = [2, 1];
        this.intperLookup[1] = [5, 9];
        this.intperLookup[2] = [6, 11];
        this.intperLookup[3] = [7, 14];

        this.state = {
            ric: "",
            symbol: "",
            name: "",
            market: "",
            change: "",
            pctchange: "",
            volume: "",
            turnover: "",
            lotsize: "",
            tradetime: "",
            yearhigh: "",
            yearlow: "",
            yearhighdate: "",
            yearlowdate: "",
            mktcap: "",
            type: this.props.type,
            ec:"",rec:""
        }
    }
    getPriceData = () => {
        axios.get("data/detail", {
            params: {
                ric: this.props.ric,
                type: 0,
                subtype: this.state.type,
                fid: 0,
                token: this.props.token
            }
        })
            .then(
                (result) => {
                    if (result.data) {
                        this.setState({
                            ric: this.props.ric,
                            symbol: result.data.basicdata.code,
                            name: result.data.basicdata.name,
                            market: result.data.basicdata.market,
                            tradeprice: result.data.basicdata.TRDPRC_1,
                            change: result.data.basicdata.NETCHNG_1,
                            pctchange: result.data.basicdata.PCTCHNG,
                            volume: result.data.ACVOL_1,
                            turnover: result.data.TURNOVER,
                            lotsize: result.data.lotsize,
                            tradetime: result.data.basicdata.TRDTIM_1,
                            yearhigh: result.data.YRHIGH,
                            yearlow: result.data.YRLOW,
                            yearhighdate: result.data.YRHIGHDAT,
                            yearlowdate: result.data.YRLOWDAT,
                            mktcap: result.data.b_mktcap,
                            ec:result.data.basicdata.sbiExchangeCode,
                            rec:result.data.basicdata.exchangeCode
                        })
                    }
                },
                // Note: it's important to handle errors here
                // instead of a catch() block so that we don't swallow
                // exceptions from actual bugs in components.
                (error) => {
                }
            )
    }
    componentDidMount() {
        this.getPriceData();
    }
    componentDidUpdate() {
        if (this.state.ric !== "" && this.props.ric !== this.state.ric) {
            this.setState({ ric: this.props.ric }, () => { this.getPriceData(); })
        }
    }
    formatNumber = (val, dp) => {
        if (val) {
            if (typeof val !== 'number') {
                val = parseFloat(val.replace(/,/g, ''));
            }
            if (dp) {
                val = new Intl.NumberFormat('en-GB', {
                    minimumFractionDigits: dp,
                    maximumFractionDigits: dp
                }).format(val);
            } else {
                val = new Intl.NumberFormat('en-GB').format(val);
            }
            return val;
        } else {
            return '-';
        }
    }
    formatPercentage = (val) => {
        if (val) {
            if (typeof val !== 'number') {
                val = parseFloat(val.replace(/,/g, ''));
            }
            return new Intl.NumberFormat('en-GB', {
                style: 'percent',
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            }).format(val);
        } else {
            return '-'
        }
    }
    formatDate = (ms) => {
        if (ms) {
            let d = new Date(ms);
            return d.toLocaleString("en-us", { month: '2-digit' }) + '/' + d.toLocaleString("en-us", { day: '2-digit' });
        } else {
            return '-';
        }
    }
    millisToHoursAndMinutes = (millis) => {
        if (millis) {
            var hours = Math.floor(millis / 60000 / 60);
            var minutes = ((millis / 60000) % 60);
            return (minutes === 60 ? (hours + 1 < 10 ? "0" : "") + (hours + 1) + ":00" : (hours < 10 ? "0" : "") + (hours) + ":" + (minutes < 10 ? "0" : "") + minutes);
        } else {
            return '-';
        }
    }
    handleAddTo = (code,exchangeCode,rexchangeCode) => (e) => {
        let url = this.props.appId==="Hyper"?Config.hyperdomain+"/5907/"+rexchangeCode+"/"+code : Config.domain+"/ETGate/?_ControlID=WPLETpfR001Control&_PageID=WPLETpfR001Eins13&_DataStoreID=DSWPLETpfR001Control&getFlg=on&_ActionID=viewPf&src_web_sec_code=" + code + "&src_sec_id=ST&src_market_id="+rexchangeCode+"&link_url=%2FETGate%2F%3F_ControlID%3DWPLETsqR001Control%26amp%3B_DataStoreID%3DDSWPLETsqR001Control%26amp%3B_PageID%3DWPLETsqR001Sdtl10%26amp%3BgetFlg%3Don%26amp%3B_ActionID%3DDefaultAID%26amp%3Bi_stock_sec%3D4307%26amp%3Bcat1%3Ddomestic%26amp%3Bcat2%3Dinfo%26amp%3Bsec_code%3D4307%26amp%3Bexchange_code%3D"+exchangeCode+"%26amp%3Bi_exchange_code%3DJPN&OutSide=on";
        window.open(url, this.props.appId==="Hyper"?"_self":"_blank"); 
    }
    render() {
        const { ric, symbol, name, market, tradeprice, change, pctchange, volume, turnover, lotsize, yearhigh, yearlow, mktcap, yearhighdate, yearlowdate, tradetime,ec,rec } = this.state;
        return (
            <div className="RAPriceBox">
                <table className="detailTable">
                    <tbody>
                        <tr>
                            <td className="stock" colSpan="3">
                                <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', height: '34px', alignItems: 'center' }}>
                                    <div> <span className="stockcode">{symbol}</span>
                                        <span className="stockname"><a href={this.props.appId==="Hyper"?Config.hyperdomain+"/1004/"+ec+"/"+symbol :Config.domain+"/ETGate/?_ControlID=WPLETsiR001Control&_PageID=WPLETsiR001Idtl10&_DataStoreID=DSWPLETsiR001Control&_ActionID=stockDetail&stock_sec_code_mul=" + symbol + "&exchange_code="+ec+"&i_dom_flg=1&i_output_type=0&getFlg=on&OutSide=on&"} rel="noopener noreferrer" target={this.props.appId==="Hyper"?"_self":"_blank"}>{name}</a></span>
                                    </div>
                                    <div> <span className="categorybox">{market}</span>
                                        <span className="addto" onClick={this.handleAddTo(symbol,ec,rec)}>追加</span>
                                    </div>
                                </div>
                            </td>
                        </tr>
                        <tr>

                            <td className="stockpricediv" colSpan="2" >
                                <div style={{ display: 'flex', flexDirection: 'column' }}>
                                    <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-end' }}>
                                        <div style={{ display: 'flex', flexDirection: 'column' }}>
                                            <div className="col1">
                                                {this.formatNumber(tradeprice, 1)}
                                            </div>
                                            <div className={"col2" + (change > 0 ? " positive" : (change < 0 ? " negative" : ""))}>
                                                {(change > 0 ? "+" : "") + this.formatNumber(change, 1)} ({(change > 0 ? "+" : "") + this.formatPercentage(pctchange / 100)})
                                            </div>
                                        </div>
                                        <div className="col3">
                                            {this.millisToHoursAndMinutes(tradetime)}
                                        </div>
                                    </div>
                                    <div className="imgcontainer">
                                        <img src={(process.env.REACT_APP_DATA_API_DOMAIN || "/sbiscrapi/") + "genchart?sym=" + ric + "&int=" + this.intperLookup[this.props.type][0] + "&per=" + this.intperLookup[this.props.type][1] + "&mode=2&bottom=2&tpoint=0&size=C1&lang=J&token=" + localStorage.getItem('SBI_JP_SCR_TOKEN')} alt="" />
                                    </div>
                                </div>
                            </td>
                            <td>
                                <div className="dataTableDiv">
                                    <table className="dataTable">
                                        <tbody>
                                            <tr>
                                                <th>出来高</th>
                                                <td>{this.formatNumber(volume)}</td>
                                            </tr>
                                            <tr>
                                                <th>売買代金<br />(千円)</th>
                                                <td>{this.formatNumber(turnover)}</td>
                                            </tr>
                                            <tr>
                                                <th>単元株数</th>
                                                <td>{this.formatNumber(lotsize)}</td>
                                            </tr>
                                            <tr>
                                                <th>年来高</th>
                                                <td>{this.formatNumber(yearhigh, 1)} ({this.formatDate(yearhighdate)})</td>
                                            </tr>
                                            <tr>
                                                <th>年来安</th>
                                                <td>{this.formatNumber(yearlow, 1)} ({this.formatDate(yearlowdate)})</td>
                                            </tr>
                                            <tr>
                                                <th className="table_bottom">時価総額<br />(百万円)</th>
                                                <td className="table_bottom">{this.formatNumber(mktcap)}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        )
    };
}